"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalDialogContent = void 0;

var _react = _interopRequireDefault(require("react"));

var _Clickable = require("../Clickable");

var _shadow = require("../../helpers/shadow");

var _Box = require("../Box");

var _Flex = require("../Flex");

var _Text = require("../Text");

var _CloseIcon = require("../../svgs/CloseIcon");

var _ArtsyLogoBlackIcon = require("../../svgs/ArtsyLogoBlackIcon");

var _useSentinelVisibility = require("../../utils/useSentinelVisibility");

var _Spacer = require("../Spacer");

var _excluded = ["children", "footer", "hasLogo", "onClose", "title"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var ModalDialogContent = function ModalDialogContent(_ref) {
  var children = _ref.children,
      footer = _ref.footer,
      hasLogo = _ref.hasLogo,
      onClose = _ref.onClose,
      title = _ref.title,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useSentinelVisibilit = (0, _useSentinelVisibility.useSentinelVisibility)(),
      topSentinel = _useSentinelVisibilit.sentinel,
      isAtTop = _useSentinelVisibilit.isSentinelVisible;

  var _useSentinelVisibilit2 = (0, _useSentinelVisibility.useSentinelVisibility)(),
      bottomSentinel = _useSentinelVisibilit2.sentinel,
      isAtBottom = _useSentinelVisibilit2.isSentinelVisible;

  return /*#__PURE__*/_react.default.createElement(_Flex.Flex, _extends({
    bg: "white100",
    flexDirection: "column",
    overflow: "hidden",
    m: 2,
    style: {
      boxShadow: _shadow.DROP_SHADOW
    }
  }, rest), /*#__PURE__*/_react.default.createElement(_Flex.Flex, {
    alignItems: "flex-start",
    justifyContent: "space-between",
    style: {
      transition: "box-shadow 250ms",
      boxShadow: isAtTop ? _shadow.DROP_SHADOW : undefined
    }
  }, (title || hasLogo) && /*#__PURE__*/_react.default.createElement(_Box.Box, {
    m: 2
  }, hasLogo && /*#__PURE__*/_react.default.createElement(_ArtsyLogoBlackIcon.ArtsyLogoBlackIcon, {
    display: "block",
    style: {
      width: "75px",
      height: "26px"
    }
  }), hasLogo && title && /*#__PURE__*/_react.default.createElement(_Spacer.Spacer, {
    mt: 2
  }), title && /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: "lg"
  }, title)), /*#__PURE__*/_react.default.createElement(_Clickable.Clickable, {
    p: 2,
    ml: "auto",
    onClick: onClose,
    "aria-label": "Close"
  }, /*#__PURE__*/_react.default.createElement(_CloseIcon.CloseIcon, {
    fill: "black100",
    display: "block"
  }))), /*#__PURE__*/_react.default.createElement(_Box.Box, {
    px: 2,
    pb: 2,
    flex: 1,
    overflow: "auto",
    style: {
      WebkitOverflowScrolling: "touch"
    }
  }, topSentinel, children, bottomSentinel), footer && /*#__PURE__*/_react.default.createElement(_Box.Box, {
    p: 2,
    style: {
      transition: "box-shadow 250ms",
      boxShadow: isAtBottom ? _shadow.DROP_SHADOW : undefined
    }
  }, footer));
};

exports.ModalDialogContent = ModalDialogContent;
ModalDialogContent.displayName = "ModalDialogContent";